export const getFileNameFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const pathSegments = urlObj.pathname.split("/");
    let fileName = pathSegments[pathSegments.length - 1];

    fileName = decodeURIComponent(fileName);

    const queryIndex = fileName.indexOf("?");
    if (queryIndex !== -1) {
      fileName = fileName.substring(0, queryIndex);
    }
    const hashIndex = fileName.indexOf("#");
    if (hashIndex !== -1) {
      fileName = fileName.substring(0, hashIndex);
    }

    const lastUnderscoreDashIndex = fileName.lastIndexOf("_-");
    if (
      lastUnderscoreDashIndex !== -1 &&
      lastUnderscoreDashIndex < fileName.length - 2
    ) {
      fileName = fileName.substring(lastUnderscoreDashIndex + 2);
    }

    return fileName || "Tệp đính kèm";
  } catch (error) {
    console.error("Invalid URL for file name extraction:", url, error);
    return "Tệp đính kèm";
  }
};
